import React from 'react';
import { Reveal } from './ui/Reveal';
import { LOGO_URL } from '../data/site';
const steps = [{
  number: '01',
  name: 'Observar',
  text: 'Miraremos tu situación actual y aquello que hoy está ocupando mayor espacio en tu vida.'
}, {
  number: '02',
  name: 'Identificar',
  text: 'Exploraremos patrones, pensamientos o comportamientos que podrían estar interfiriendo con aquello que quieres construir.'
}, {
  number: '03',
  name: 'Comprender',
  text: 'Conectaremos lo que estás viviendo con el código que necesita mayor atención.'
}, {
  number: '04',
  name: 'Definir',
  text: 'Estableceremos qué necesitas comenzar a trabajar y cuál podría ser tu siguiente paso.'
}, {
  number: '05',
  name: 'Accionar',
  text: 'Te llevarás una hoja de ruta inicial para comenzar a avanzar con mayor claridad.'
}];
export function OfferSection() {
  return <section className="bg-cream px-6 py-20 sm:py-28" data-id="element-189" data-mp="2y3kvlujeq58b">
      <div className="mx-auto max-w-4xl" data-id="element-190" data-mp="2y6790aszbeyg">
        <Reveal data-id="element-191" data-mp="12ojzyn1w6mr1">
          <div className="text-center" data-id="element-192" data-mp="12oa5on9tdtfj">
            <img src={LOGO_URL} alt="" aria-hidden="true" className="mx-auto w-28 sm:w-32" data-id="element-193" data-mp="xws7g6z6e6y9" />
            <h2 className="mt-6 font-serif text-[1.75rem] font-light uppercase tracking-[0.12em] text-ink sm:text-4xl" data-id="element-194" data-mp="sy8idxpacf1o">
              La Herradura Dorada
            </h2>
            <p className="mx-auto mt-5 max-w-xl font-serif text-xl font-light italic leading-snug text-gold-dark sm:text-2xl" data-id="element-195" data-mp="1lmmkopnepxj1">
              Una sesión privada para volver a ti, identificar lo que podría
              estar bloqueándote y encontrar tu próximo paso con claridad.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-196" data-mp="17m3cniixyrgv">
          <div className="mx-auto mt-12 max-w-2xl space-y-5 text-[17px] leading-relaxed text-ink-soft sm:text-[19px]" data-id="element-197" data-mp="17oxvx6q7y68p">
            <p data-id="element-198" data-mp="3sd3s5mhsn4wg">
              El test puede darte una primera perspectiva. Pero una cosa es
              conocer un patrón y otra muy diferente es detenerte a observar
              cómo ese patrón está apareciendo específicamente en tu vida.
            </p>
            <p data-id="element-199" data-mp="2mwyzbyn7ybc">
              Por eso creé{' '}
              <span className="text-ink" data-id="element-200" data-mp="3ktul3zwrfiak">La Herradura Dorada</span>. Un espacio
              privado de 45 minutos en el que voy a acompañarte personalmente
              para comprender mejor tu momento actual y ayudarte a definir un
              camino inicial.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.15} data-id="element-201" data-mp="3fui25q90evd9">
          <p className="mt-16 text-center text-[10px] font-semibold uppercase tracking-[0.26em] text-gold-dark sm:text-[11px]" data-id="element-202" data-mp="3fvjavo2jz5rt">
            En la sesión vamos a
          </p>
        </Reveal>

        <ol className="mt-10 space-y-1" data-id="element-203" data-mp="364ydg3ym87ah">
          {steps.map((step, i) => <li key={step.number} data-id="element-204" data-mp="2s5p0re9mbvb9" data-mpi={i}>
              <Reveal delay={i * 0.08} data-id="element-205" data-mp="2s6qmcco9g078">
                <div className="flex gap-5 sm:gap-7" data-id="element-206" data-mp="2x48kr94nix0z">
                  {/* Timeline rail */}
                  <div className="flex flex-col items-center" data-id="element-207" data-mp="2dhf6blp53x6h">
                    <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border border-gold/45 bg-ivory font-serif text-[15px] text-gold-dark" data-id="element-208" data-mp="2dk1e9mfy0ep8">
                      {step.number}
                    </span>
                    {i < steps.length - 1 && <span className="mt-1 w-px flex-1 bg-gold/30" aria-hidden="true" data-id="element-209" data-mp="2ifqgxyn9ebpr" />}
                  </div>

                  <div className="pb-9 pt-2" data-id="element-210" data-mp="2rflx6hvo8wwn">
                    <h3 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-ink" data-id="element-211" data-mp="3674bmb8vujdw">
                      {step.name}
                    </h3>
                    <p className="mt-3 max-w-xl text-[16.5px] leading-relaxed text-ink-soft sm:text-[18px]" data-id="element-212" data-mp="319m6yx1weqbp">
                      {step.text}
                    </p>
                  </div>
                </div>
              </Reveal>
            </li>)}
        </ol>
      </div>
    </section>;
}